<template>
    <div class="inline">
        <a @click.stop="showCommentsModal" href="javascript:void(0)" class="mr-3" class2="btn btn-xs btn-secondary font-semibold hover:bg-gray-200">
            {{ __('Reply') }}
        </a>

        <portal v-if="showCommentModal" to="modals">
            <comment-modal v-if="showCommentModal" @added="onAdded" @close="onCommentModalClosed" :resource-type="resourceType" :resource-id="resourceId" :parent-id="parentId" />
        </portal>
    </div>
</template>

<script>
export default {
    props: [
        'resource-type',
        'resource-id',
        'parent-id',
    ],

    data: () => ({
        showCommentModal: false,
    }),

    created() {},

    mounted() {},

    computed: {},

    methods: {
        showCommentsModal() {
            this.showCommentModal = true;
        },

        onAdded() {
            // @todo refresh comment list
            window.location.reload();
        },

        onCommentModalClosed() {
            this.showCommentModal = false;
        },
    }
}
</script>

<style lang="scss" scoped>
</style>
